const { createSlice } = require('@reduxjs/toolkit');

const globalDataSlice = createSlice({
    name: "globalData",
    initialState: {
        globalDataName: {},
        
    },
    reducers: {
        setglobalData(state, action) {
            const globalDataName = action.payload;

            return state = {
                globalDataName
            };
            
           
        }
    },
});

export const { setglobalData } = globalDataSlice.actions;
export default globalDataSlice.reducer;
